// import Vue from 'vue'
import { mapState } from 'vuex';
import { deviceEnquire, DEVICE_TYPE } from '@/utils/device';

// const mixinsComputed = Vue.config.optionMergeStrategies.computed
// const mixinsMethods = Vue.config.optionMergeStrategies.methods

const mixin = {
  computed: {
    ...mapState({
      layoutMode: (state) => state.system.app.layout,
      navTheme: (state) => state.system.app.theme,
      primaryColor: (state) => state.system.app.color,
      colorWeak: (state) => state.system.app.weak,
      fixedHeader: (state) => state.system.app.fixedHeader,
      fixSiderbar: (state) => state.system.app.fixSiderbar,
      fixSidebar: (state) => state.system.app.fixSiderbar,
      contentWidth: (state) => state.system.app.contentWidth,
      autoHideHeader: (state) => state.system.app.autoHideHeader,
      sidebarOpened: (state) => state.system.app.sidebar,
      multiTab: (state) => state.system.app.multiTab,
      searchMenu: (state) => state.system.app.searchMenu,
      navMenu: (state) => state.system.app.navMenu,
      permission: (state) => state.system.app.permission,
      showChangeColor: (state) => state.system.app.showChangeColor,
      showChangeLanguage: (state) => state.system.app.showChangeLanguage,
      showTips: (state) => state.system.app.showTips,
    }),
  },
  methods: {
    isTopMenu() {
      return this.layoutMode === 'topmenu';
    },
    isSideMenu() {
      return !this.isTopMenu();
    },
  },
};

const mixinDevice = {
  computed: {
    ...mapState({
      device: (state) => state.system.app.device,
    }),
  },
  methods: {
    isMobile() {
      return this.device === DEVICE_TYPE.MOBILE;
    },
    isDesktop() {
      return this.device === DEVICE_TYPE.DESKTOP;
    },
    isTablet() {
      return this.device === DEVICE_TYPE.TABLET;
    },
  },
};

const AppDeviceEnquire = {
  mounted() {
    const { $store } = this;
    deviceEnquire((deviceType) => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('system/app/TOGGLE_DEVICE', 'desktop');
          // $store.dispatch('system/app/setSidebar', true);
          break;
        case DEVICE_TYPE.TABLET:
          $store.commit('system/app/TOGGLE_DEVICE', 'tablet');
          $store.dispatch('system/app/setSidebar', false);
          break;
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('system/app/TOGGLE_DEVICE', 'mobile');
          $store.dispatch('system/app/setSidebar', true);
          break;
      }
    });
  },
};

// 每个路由页面对应的基础数据
const page = {
  data() {
    return {
      pageLoading: false,
      pageDelayTime: 200,
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.pageLoading = true;
    // }, 0);
    // setTimeout(() => {
    //   this.pageLoading = false;
    // }, 3000);
  },
  methods: {
    showLoading() {
      this.pageLoading = true;
    },
    hiddenLoading() {
      this.pageLoading = false;
    },
    /**
     *
     * @param {Object} param0 { tabId: 要关闭的标签名字,默认当前,to: router.push参数，表示删除后要打开的地址，默认{},callback: 删除成功后回调函数 }
     */
    closePage({ tabId, to, callback } = {}) {
      let newTabId = this.$route.meta.tabId;
      if (tabId) {
        newTabId = tabId;
      }
      this.$store
        .dispatch('system/page/close', {
          tabId: newTabId,
          to,
        })
        .then(() => {
          // 关闭后执行的动作，一般打开另一个tab
          if (callback) {
            callback();
          }
        });
    },
  },
};

export { mixin, AppDeviceEnquire, mixinDevice, page };
